import Component from "gia/Component";
import Splide from "@splidejs/splide";
import gsap from "gsap";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    this.buildSlideshow();
  }

  moveProgressBar(slideshow, progressBar) {
    var end = slideshow.Components.Controller.getEnd() + 1;
    const width = `calc((1/${end}) * 100%)`;
    gsap.set(progressBar, { x: `${slideshow.index * 100}%`, width: width });
  }

  buildSlideshow() {
    // console.log(this.DOM.view);
    if(this.ref.slider != null) {
      this.DOM.progressbar = this.DOM.view.querySelector('c-progressbar');
      this.slideshow = new Splide(this.ref.slider[0], {
        arrows: true,
        gap: 32,
        padding: { left: 64, right: 64 },
        pauseOnFocus: false,
        pauseOnHover: false,
        pagination: false,
        perPage: 4,
        perMove: 1,
        rewind: true,
        speed: 700,
        type: "slide",
        omitEnd: false,
        breakpoints: {
          640: {
            gap: 12,
            padding: { left: 12, right: 12 },
            perPage: 1,
            fixedWidth: "85%",
          },
        },
      });
      this.slideshow.on('mounted move', () => {
        if (typeof this.DOM.progressbar != 'undefined') {
          this.moveProgressBar(this.slideshow, this.DOM.progressbar);
        }
      });

      this.slideshow.mount();
    }
  }

  unmount() {}
}
